import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { StInputBase } from './TextBox.style';
import { useTheme } from '@mui/material/styles';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';
import { useState } from 'react';

const TextBox = (props: any): JSX.Element => {
  const theme = useTheme();
  const [err, setError] = useState('');

  const handleCombinedOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (props?.required && event.target.value.trim() === '') {
      setError(props.requiredMessage?.value);
    } else {
      setError('');
    }
    if (props?.onBlurHandler) {
      props.onBlurHandler(event, props?.name);
    }
  };
  const showErrorState = props?.error || props?.regexError || !!err;
  let messageToDisplay = '';
  if (props?.regexError) {
    messageToDisplay = props.regexMessage?.value;
  } else if (err) {
    messageToDisplay = err;
  }

  return (
    <FormControl fullWidth>
      <StInputBase
        placeholder={props?.placeholder}
        onChange={(event) => props?.onChangeHandler(event, props?.name)}
        required={props?.required}
        error={showErrorState}
        value={props?.value}
        inputProps={{
          color: theme.palette.neutral11.main,
          maxLength: props?.maxLength,
          ...(props.id && { id: props.id }),
          ...(props.name && { name: props.name }),
        }}
        onBlur={handleCombinedOnBlur}
      />
      {showErrorState && messageToDisplay && (
        <Typography
          sx={{
            color: theme.palette.error.main,
            fontSize: '13px',
            fontFamily: `${
              theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY
            }, sans-serif`,
            lineHeight: '24px',
            fontWeight: 400,
          }}
        >
          {messageToDisplay}
        </Typography>
      )}
    </FormControl>
  );
};

export default TextBox;
